const MAIN_APP_URL_ENV = process.env.REACT_APP_MAIN_APP_URL;
const DEFAULT_MAIN_APP_URL = 'http://localhost:3000/';

export function getMainAppUrl(): string {
  if (MAIN_APP_URL_ENV && MAIN_APP_URL_ENV.trim()) {
    return MAIN_APP_URL_ENV.trim();
  }

  return DEFAULT_MAIN_APP_URL;
}

export function redirectToMainApp(): void {
  if (typeof window !== 'undefined') {
    window.location.href = getMainAppUrl();
  }
}
